/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SymbolWithExchangeDto,
    SymbolWithExchangeDtoFromJSON,
    SymbolWithExchangeDtoFromJSONTyped,
    SymbolWithExchangeDtoToJSON,
} from './SymbolWithExchangeDto';

/**
 * 
 * @export
 * @interface SymbolSplitDto
 */
export interface SymbolSplitDto {
    /**
     * 
     * @type {SymbolWithExchangeDto}
     * @memberof SymbolSplitDto
     */
    symbol: SymbolWithExchangeDto;
    /**
     * 
     * @type {Date}
     * @memberof SymbolSplitDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof SymbolSplitDto
     */
    ratio: string;
    /**
     * 
     * @type {number}
     * @memberof SymbolSplitDto
     */
    ratioValue: number;
}

export function SymbolSplitDtoFromJSON(json: any): SymbolSplitDto {
    return SymbolSplitDtoFromJSONTyped(json, false);
}

export function SymbolSplitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolSplitDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbol': SymbolWithExchangeDtoFromJSON(json['symbol']),
        'date': (new Date(json['date'])),
        'ratio': json['ratio'],
        'ratioValue': json['ratioValue'],
    };
}

export function SymbolSplitDtoToJSON(value?: SymbolSplitDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbol': SymbolWithExchangeDtoToJSON(value.symbol),
        'date': (value.date.toISOString()),
        'ratio': value.ratio,
        'ratioValue': value.ratioValue,
    };
}

